import { TERMS_VERSION, legalDateLabel, termsUrl } from "@school-sales-ai/shared";
import { LegalPageShell } from "@/components/legal/LegalPageShell";
import { TermsContent } from "@/components/legal/TermsContent";
import { brandFromLocation } from "@/lib/brand";

/**
 * Public, anonymous: the terms must be readable before anyone logs in, and
 * linkable from the login screen. The same text is shown inside the CRM's
 * acceptance gate via `TermsContent`.
 */
export function TerminosYCondiciones(): React.JSX.Element {
  const brand = brandFromLocation();
  const lastUpdated = legalDateLabel(TERMS_VERSION);

  return (
    <LegalPageShell brand={brand} canonicalHref={termsUrl(brand)} lastUpdated={lastUpdated}>
      <TermsContent brand={brand} lastUpdated={lastUpdated} />
    </LegalPageShell>
  );
}
